var { FormatTypeId, SingletonId, typeUnionId } = require("../../../typing/typing");
var External = require("./Constructors").External;
var LambdaTermId = require("./LambdaTermId");
var LambdaJSONId = require("./JSON").LambdaJSONId;

/**
 * unbox external lambda term.
 * If a term is not `External`, return `undefined`.
 * Otherwise return unboxed object, i.e. `term.object`.
 * An optional argument `objType` ensures that unboxed object is of given type.
 *
 * One can use `unboxExternal(term) !== undefined` instead of `isExternal(term)`
 *   to determine whether `term` is an External lambda term.
 * @param {LambdaTerm} term - a lambda term
 * @param {string} objType - a lambda type (optional)
 * @return unboxed object if the term is `External` and of given type,
 *         undefined otherwise
 **/
function unboxExternal(term, objType) {
  if(term instanceof External)
    if(objType === undefined || term.objType === objType)
      return term.object;
  return undefined;
}

/**
 * wrap a term to lambda object.
 * If given term is External lambda term, return unwrapped object instead.
 * @param {LambdaTerm} term - a lambda term
 * @return {@link LambdaObject} or unboxed External object.
 */
function wrapToObject(term) {
  return (term instanceof External)
    ? term.object
    : { type: "Lambda", term: term };
}

/** Id of lambda object. */
var LambdaObjectId = FormatTypeId({
    type: SingletonId("Lambda", "Lambda type marker"),
    term: typeUnionId(LambdaTermId, LambdaJSONId)
  }, "Lambda object");

LambdaObjectId.typeName = "Lambda object";

module.exports = {
  unboxExternal: unboxExternal,
  wrapToObject: wrapToObject,
  LambdaObjectId: LambdaObjectId
};
